import React, { useState, useEffect } from "react";
import { InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import { CmrMinRoomHeight, CmrMinRoomWidth } from "data/newObject";
import { useTypedSelector } from "hooks/store";
import { builder } from "Classes/global";
import { SelectChangeEvent } from "@mui/material";

const AddEditObjectRoomSizeComponent = (): JSX.Element => {
    const isOpen = useTypedSelector((store) => store.ModelWindow.isModelOpen);

    const [width, setWidth] = useState<number>(CmrMinRoomWidth);
    const [depth, setDepth] = useState<number>(CmrMinRoomHeight);
    const [size, setSize] = useState<string>("placeholder");

    useEffect(() => {
        if (isOpen) {
            const { length, width } = builder._roomSize;
            setDepth(length);
            setWidth(width);
        }
    }, [isOpen]);

    /**
     * Update state based on input type.
     * @param event
     */
    const handleUpdate = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;

        if (value === "placeholder") {
            return;
        }

        let newWidth = 4;
        let newDepth = 4;

        switch (value) {
            case "small":
                newWidth = 4;
                newDepth = 4;
                break;

            case "medium":
                newWidth = 8;
                newDepth = 8;
                break;

            case "large":
                newWidth = 12;
                newDepth = 12;
                break;
        }

        setWidth(newWidth);
        setDepth(newDepth);

        builder.updateRoomSize({
            width: newWidth,
            length: newDepth,
            height: builder._roomSize.height,
        });
    };

    return (
        <div className="roomSizeContainer">
            <h2 className="desktop-title">Room Size</h2>

            <FormControl fullWidth>
                <InputLabel id="room-select-label">Select Size</InputLabel>
                <Select
                    labelId="room-select-label"
                    id="room-select"
                    value={size}
                    onChange={handleUpdate}
                >
                    <MenuItem value="placeholder">Select Size</MenuItem>
                    <MenuItem value="small">Small</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="large">Large</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};

export default AddEditObjectRoomSizeComponent;
